import { StateCreator } from "zustand";
import { User } from "../services/User";

export interface AuthenticationSlice {
  accessToken: string;
  refreshToken: string;
  user: User | null;
  isAuthenticated: () => boolean;
  setAccessToken: (token: string) => void;
  setRefreshToken: (token: string) => void;
  setUser: (user: User | null) => void;
  removeAccessToken: () => void;
  removeRefreshToken: () => void;
  getAccessToken: () => string;
  getRefreshToken: () => string;
  getUser: () => User | null;
}

export const createAuthenticationSlice: StateCreator<
  AuthenticationSlice,
  [],
  [],
  AuthenticationSlice
> = (set, get, _) => ({
  accessToken: "",
  refreshToken: "",
  user: null,
  setAccessToken: (accessToken: string) => set(() => ({ accessToken: accessToken })),
  setRefreshToken: (refreshToken: string) => set(() => ({ refreshToken: refreshToken })),
  setUser: (user: User | null) => set(() => ({ user: user })),
  removeAccessToken: () => set(() => ({ accessToken: "" })),
  removeRefreshToken: () => set(() => ({ refreshToken: "" })),
  getAccessToken: () => get().accessToken,
  getRefreshToken: () => get().refreshToken,
  isAuthenticated: () => get().accessToken !== "",
  getUser: () => get().user,
});
